import { useCallback, useRef } from 'react'

import { useAsync } from 'core/ui/hooks/useAsync'

import {
  type OpenDockCancelDialogMutationParams,
  type OpenDockCancelOrResetOption,
  openDockCancelFromDialog as openDockCancelUsecase,
} from '../../use-cases/openDockCancelDialogMutation'

export function useCancelOpenDockWarehouseAppointment() {
  const lastOptionRef = useRef<OpenDockCancelOrResetOption | null>(null)

  const openDockCancelFromDialog = useCallback(
    async (params: OpenDockCancelDialogMutationParams) => {
      lastOptionRef.current = params.option
      return openDockCancelUsecase(params)
    },
    []
  )

  const { call, reset, status, isPending } = useAsync(openDockCancelFromDialog)

  const resetMutation = useCallback(() => {
    lastOptionRef.current = null
    reset()
  }, [reset])

  return {
    call,
    isPending,
    lastOptionRef,
    requestStatus: status,
    resetMutation,
  }
}
